import { render, staticRenderFns } from "./defaultParamsManager.vue?vue&type=template&id=936fb2f6&scoped=true&"
import script from "./defaultParamsManager.vue?vue&type=script&lang=js&"
export * from "./defaultParamsManager.vue?vue&type=script&lang=js&"
import style0 from "./defaultParamsManager.vue?vue&type=style&index=0&id=936fb2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936fb2f6",
  null
  
)

export default component.exports